import { TSelectedTicketFile, TTicketFile } from 'pages/new-service/types/NewService.types'

async function getBase64({
  file,
  onSucces,
  onFail,
}: {
  file: File
  onSucces?: () => void
  onFail?: () => void
}): Promise<string | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const { result } = reader
      onSucces?.()
      if (typeof result === 'string') resolve(result)
      resolve(null)
    }
    reader.onerror = () => {
      onFail?.()
      reject(new Error('Failed to read file'))
    }
  })
}

export async function selectFiles(event: FileList) {
  let files: TTicketFile[] = []
  for (let i = 0; i < event.length; i++) {
    const file = event.item(i)
    if (file) {
      const base64File = await getBase64({ file })

      if (base64File) {
        files = [
          ...files,
          {
            name: file.name,
            size: file.size,
            type: file.type,
            base64: base64File.toString(),
          },
        ]
      }
    }
  }
  return files
}

export function selectTicketFiles(event: FileList) {
  let files: TSelectedTicketFile[] = []

  for (let i = 0; i < event.length; i++) {
    const file = event.item(i)

    if (file) {
      files = [
        ...files,
        {
          file,
          name: file.name,
          size: file.size,
          type: file.type,
        },
      ]
    }
  }

  return files
}

export function verifyFiles(files: Array<Pick<TSelectedTicketFile, 'size'>>) {
  const size = (fileSize: number) => Math.round(fileSize / 1000)
  const sizeLimit = 10240

  const aboveSizeLimit = files.filter((file) => size(file.size) > sizeLimit).length > 0

  const totalSize = files
    .map(({ size: fileSize }) => fileSize)
    .reduce((prev, curr) => prev + curr, 0)

  return { aboveSizeLimit, totalSize }
}
